
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.953 5.04c.396 0 .716.13.961.39s.367.593.367 1c0 .422-.122.763-.367 1.023-.245.255-.565.383-.96.383-.386 0-.701-.128-.946-.383-.24-.26-.36-.601-.36-1.023 0-.412.12-.745.36-1 .245-.26.56-.39.945-.39zM6.945.304c1.12 0 2.151.258 3.094.773a5.496 5.496 0 012.211 2.18c.537.937.805 1.995.805 3.172 0 1.146-.26 2.187-.782 3.125a5.601 5.601 0 01-2.203 2.203c-.942.531-1.984.797-3.125.797-1.135 0-2.177-.263-3.125-.79A5.563 5.563 0 011.625 9.57c-.52-.937-.781-1.984-.781-3.14 0-1.172.265-2.227.797-3.164a5.563 5.563 0 012.203-2.188C4.78.562 5.815.305 6.945.305zM6.937 1.39c-.89 0-1.705.213-2.445.64a4.451 4.451 0 00-1.726 1.797C2.349 4.6 2.14 5.466 2.14 6.43c0 .958.203 1.823.609 2.593a4.5 4.5 0 001.734 1.797 4.8 4.8 0 002.454.649c.921 0 1.752-.216 2.492-.649a4.382 4.382 0 001.718-1.804c.407-.771.61-1.633.61-2.586 0-.97-.208-1.839-.625-2.61a4.384 4.384 0 00-1.727-1.797c-.734-.421-1.557-.632-2.469-.632z","fill":"currentColor"}})])
          )
        }
      }
    